import { render } from "./text-editor.vue?vue&type=template&id=70c393bd&scoped=true"
import script from "./text-editor.vue?vue&type=script&lang=js"
export * from "./text-editor.vue?vue&type=script&lang=js"

import "./text-editor.vue?vue&type=style&index=0&id=70c393bd&lang=scss&scoped=true"
import "./text-editor.vue?vue&type=style&index=1&id=70c393bd&lang=scss"
script.render = render
script.__scopeId = "data-v-70c393bd"

export default script